<template>
  <div>
    <h2>Keywords</h2>
    <p>Click keywords to plan video concepts.</p>
    <div>
      <div class="strategy-board" v-if="creator.strategy.pillars">
        <div class="strategy-keyword-column" v-for="pillar in creator.strategy.pillars" :key="pillar.pillarID">
          <div v-if="pillar.keywords">
            <div v-if="pillar.keywords.length">
              <h3>{{pillar.data.pillarName}}</h3>
              <div class="strategy-keyword-card" v-for="keyword in pillar.keywords" :key="keyword.keywordID">
                <div class="pillar-description">
                  <h4 @click="formatKeywordStats(keyword)" v-b-modal="'keywordStats'+keyword.keywordID">{{keyword.data.keywordName}}</h4>
                  <i class="fa fa-trash strategy" v-b-modal="'keywordDelete'+keyword.keywordID"></i>
                  <p @click="formatKeywordStats(keyword)" v-b-modal="'keywordStats'+keyword.keywordID" class="artist"></p>
                </div>
                <b-modal
                  :id="'keywordDelete'+keyword.keywordID"
                  :title="'Are you sure you want to delete keyword: ' + keyword.data.keywordName + '?'"
                  centered
                  @ok="deleteKeyword(pillar, keyword)"
                >
                </b-modal>
                <b-modal
                  :id="'keywordStats'+keyword.keywordID"
                  :title="'Keyword Stats: ' + keyword.data.keywordName"
                  centered
                  size="xl"
                >
                  <div class="results-section">
                    <div class="grades-section">
                      <div class="gauge-stats">
                        <VueSvgGauge
                          :start-angle="-110"
                          :end-angle="110"
                          :value="viewsRating"
                          :separator-step="1"
                          :min="0"
                          :max="4"
                          :gauge-color="[{ offset: 0, color: '#ff0000'}, { offset: 100, color: '#8CDFAD'}]"
                          :inner-radius="70"
                          :scale-interval="0"
                        >
                        </VueSvgGauge>
                        <div class="inner-text">
                          <h3>{{formatStat(keyword.data.avgViews)}} avg views</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                <h2>Concepts</h2>
                <div class="concept-board">
                  <div
                    v-for="concept in keyword.data.concepts"
                    :key="concept.conceptName"
                    class="strategy-concept-card"
                  >
                    <div class="pillar-description">
                      <h4>{{ concept }}</h4>
                      <i
                        class="fa fa-trash" v-b-modal="'deleteConcept'+concept"
                      ></i>
                      <button class="concept-button" v-b-modal="'startProduction'+concept">Start Production</button>
                    </div>
                    <b-modal
                      :id="'deleteConcept'+concept"
                      :title="'Delete Concept?'"
                      @ok="deleteConcept(pillar, keyword, concept)"
                    >{{concept}}
                    </b-modal>
                    <b-modal
                      :id="'startProduction'+concept"
                      title="Start Production"
                      @ok="startProduction(keyword, concept)"
                    >
                      <b-form @submit.prevent="addNewConcept">
                        <b-form-group
                          label="Publish Date"
                          label-for="input-1"
                          description="This is the date you'll publish your video to YouTube."
                        >
                          <b-form-datepicker
                            id="input-1"
                            v-model="publishDate"
                            required
                          >
                          </b-form-datepicker>
                        </b-form-group>
                      </b-form>
                    </b-modal>
                  </div>
                  <button class="keyword-button" v-b-modal="'newConcept'+keyword.data.keywordName">+</button>
                </div>
                </b-modal>
                <b-modal
                  :id="'newConcept'+keyword.data.keywordName"
                  :title="'New Concept for ' + keyword.data.keywordName"
                  @ok="addNewConcept(pillar, keyword)"
                >
                  <b-form @submit.prevent="addNewConcept">
                    <b-form-group
                      description="What's your video concept for this keyword?"
                    >
                      <b-form-input
                        v-model="conceptName"
                        type="text"
                        required
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-form>
                </b-modal>
              </div>
            </div>
            <h4 v-else>No keywords
              <br>for {{pillar.data.pillarName}}
            </h4>
          </div>
          <button class="keyword-button" v-b-modal="'keywordToolModal'+pillar.pillarID">+</button>
          <b-modal
            :id="'keywordToolModal'+pillar.pillarID"
            :ref="'keywordToolModal'+pillar.pillarID"
            centered
            :title="'New Keyword for '+pillar.data.pillarName"
            @hide="resetParameters"
            size="xl"
            hide-footer
          >
            <b-form-group>
              <b-input-group size="lg">
                <b-form-input
                  id="filter-input"
                  type="search"
                  placeholder="Search"
                  v-model="searchTerm"
                  @input="runAutocomplete"
                  @keydown.enter="researchStep(searchTerm)"
                  autocomplete="off"
                ></b-form-input>
                <b-input-group-append>
                  <b-button>
                    <img
                      src="../../../../../public/resources/images/icons/search.svg"
                      @click="researchStep(searchTerm)"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div>
              <p
                :class="$style.item"
                v-for="suggestion in autocompleteItems"
                :key="suggestion"
                @click="researchStep(suggestion)"
              >
                {{ suggestion }}
              </p>
            </div>
            <div v-if="searchResult" class="results-section">
              <h4>Keyword: {{searchTerm}}</h4>
              <div class="grades-section" v-if="!showCommitment">
                <div class="gauge-stats">
                  <VueSvgGauge
                    :start-angle="-110"
                    :end-angle="110"
                    :value="viewsRating"
                    :separator-step="1"
                    :min="0"
                    :max="4"
                    :gauge-color="[{ offset: 0, color: '#ff0000'}, { offset: 100, color: '#8CDFAD'}]"
                    :inner-radius="70"
                    :scale-interval="0"
                  >
                  </VueSvgGauge>
                  <div class="inner-text">
                    <h3>{{formatStat(avgViews)}} avg views</h3>
                  </div>
                </div>
                <div v-if="showRelatedTerms" class="results-stats">
                  <h6>Related Terms:</h6>
                  <span v-for="tag in relatedTagsFilter" :key="tag" class="btn btn-3" @click="researchStep(tag)">{{tag}}</span>
                  <!-- <button class="btn" v-show="limitTags" @click="switchLimit">Show More</button>
                  <button class="btn" v-show="!limitTags" @click="switchLimit">Show Less</button> -->
                </div>
              </div>
              <div v-if="showCommitment" class="thumbnails-section">
                <h1>Can you beat these titles and thumbnails?</h1>
                <div class="thumbnails-section">
                  <div class="video-container keyword-tool" v-for="video in videosList" :key="video.id.videoId">
                    <div class="thumbnail-keyword-tool">
                      <img
                        :src="`http://i3.ytimg.com/vi/${video.id.videoId}/mqdefault.jpg`"
                        class="thumbnail-image-keyword-tool">
                    </div>
                    <div class="video-bottom-section">
                      <a href="">
                        <img src="" alt="">
                      </a>
                      <div class="video-details">
                        <div class="video-title">{{video.encodedTitle}}</div>
                        <div class="video-channel-name">{{video.snippet.channelTitle}}</div>
                        <div class="video-metadata">
                          <span>{{formatStat(video.views)}} views</span>
                          •
                          <span>{{formatDate(video.snippet.publishedAt)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="keyword-tool-buttons">
                <button class="btn" @click="resetParameters">Restart</button>
                <button v-if="!showCommitment" class="btn btn-sales" @click="showCommitmentStep">Next</button>
                <button v-if="showCommitment" class="btn btn-sales" @click="addKeyword(pillar)">Add Keyword</button>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import moment from 'moment'
import { VueSvgGauge } from 'vue-svg-gauge'

var decode = require('unescape')

export default {
  name: 'keywords',
  components: { VueSvgGauge },
  data() {
    return {
      searchTerm: null,
      searchResult: null,
      avgViews: null,
      allTags: [],
      limitTags: true,
      videosList: [],
      autocompleteItems: [],
      showCommitment: false,
      showRelatedTerms: false,
      conceptName: null,
      publishDate: null,
    }
  },
  computed: {
    ...mapState(['creator']),
    ...mapState(['youtube']),
    okDisabled() {
      if (this.searchTerm == null) {
        return true
      } return false
    },
    relatedTagsFilter() {
      return this.limitTags ? this.allTags.slice(0, 15) : this.allTags
    },
    viewsRating() {
      if (this.avgViews < 10000) {
        return this.avgViews / 10000
      } else if (this.avgViews < 100000) {
        return (this.avgViews / 100000) + 1
      } else if (this.avgViews < 1000000) {
        return (this.avgViews / 1000000) + 2
      } else if (this.avgViews < 10000000) {
        return (this.avgViews / 10000000) + 3
      } else return 4
    },
  },
  methods: {
    runAutocomplete() {
      const acUrl = 'https://clients1.google.com/complete/search'
      axios({
        url: acUrl,
        adapter: jsonpAdapter,
        params: {
          client: 'youtube',
          hl: 'en',
          ds: 'yt',
          q: this.searchTerm,
        },
      })
        .then(res => {
          this.autocompleteItems = res.data[1].map(item => item[0])
        })
    },
    researchStep(searchTerm) {
      if (searchTerm !== '') {
        this.autocompleteItems = []
        this.youtubeSearch(searchTerm)
        this.searchTerm = searchTerm
      }
    },
    youtubeSearch(searchTerm) {
      this.limitTags = true
      const tagsGetter = this.tagsGetter
      const viewsGetter = this.viewsGetter
      const apiKey = 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc'
      axios
        .get(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=8&q=${searchTerm}&type=video&key=${apiKey}`)
        .then(res => {
          console.log(res)
          this.videosList = res.data.items
          const mapVideos = async() => {
            return Promise.all(this.videosList.map(async function (video) {
              const tags = await tagsGetter(video)
              const views = await viewsGetter(video)
              return {
                id: video.id,
                snippet: video.snippet,
                encodedTitle: decode(video.snippet.title),
                tags,
                views,
              }
            }))
          }
          mapVideos().then(data => {
            // views
            this.videosList = data
            console.log(this.videosList)
            console.log(decode(this.videosList[1].snippet))
            const viewTotals = data.reduce((acc, val) => acc + Number(val.views), 0)
            this.avgViews = viewTotals / data.length
            // tags
            const allTags = []
            data.forEach(video => {
              const tags = video.tags
              allTags.push(tags)
            })
            this.allTags = [...new Set(allTags.flat())]
            function shuffle(array) {
              let currentIndex = array.length
              let randomIndex
              while (currentIndex !== 0) {
                randomIndex = Math.floor(Math.random() * currentIndex)
                currentIndex--
                [array[currentIndex], array[randomIndex]] = [
                  array[randomIndex], array[currentIndex]]
              }
              return array
            }
            shuffle(this.allTags)
            this.searchResult = true
            this.showRelatedTerms = true
          })
        })
        .catch(error => console.log(error))
    },
    async tagsGetter(video) {
      try {
        const apiKey = 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc'
        var tags =
          await axios
            .get(`https://youtube.googleapis.com/youtube/v3/videos?part=snippet&id=${video.id.videoId}&key=${apiKey}`)
            .then(res => {
              return res.data.items[0].snippet.tags
            })
            .catch(error => console.log(error))
        return tags
      } catch (err) {
        console.log(err)
      }
    },
    async viewsGetter(video) {
      try {
        const apiKey = 'AIzaSyA2a7e3NA1RyZbyCw2Zt9jSpBjnp1xzzRc'
        var views =
          await axios
            .get(`https://youtube.googleapis.com/youtube/v3/videos?part=statistics&id=${video.id.videoId}&key=${apiKey}`)
            .then(res => {
              return Number(res.data.items[0].statistics.viewCount)
            })
            .catch(error => console.log(error))
        return views
      } catch (err) {
        console.log(err)
      }
    },
    switchLimit() {
      this.limitTags = !this.limitTags
    },
    showCommitmentStep() {
      this.showRelatedTerms = false
      this.showCommitment = true
    },
    formatKeywordStats(keyword) {
      this.avgViews = keyword.data.avgViews
    },
    formatStat(stat) {
      if (stat < 1000) {
        return stat
      } else if (stat < 1100) {
        return '1K'
      } else if (stat < 10000) {
        return (Math.floor(stat / 1000 * 10) / 10 + 'K')
      } else if (stat < 1000000) {
        return (Math.floor(stat / 1000) + 'K')
      } else if (stat < 1100000) {
        return '1M'
      } else if (stat < 10000000) {
        return (Math.floor(stat / 1000000 * 10) / 10 + 'M')
      } else return (Math.floor(stat / 1000000) + 'M')
    },
    formatDate(publishedAt) {
      const today = moment()
      const comparison = today.diff(publishedAt, 'days')
      if (comparison < 2) {
        return '1 day ago'
      } else if (comparison < 7) {
        return (comparison + ' days ago')
      } else if (comparison < 12) {
        return '1 week ago'
      } else if (comparison < 31) {
        return (Math.round(comparison / 7) + ' weeks ago')
      } else if (comparison < 50) {
        return '1 month ago'
      } else if (comparison < 349) {
        return (Math.round(comparison / 30.5) + ' months ago')
      } else if (comparison < 600) {
        return '1 year ago'
      } else return (Math.round(comparison / 365) + ' years ago')
    },
    addKeyword(pillar) {
      console.log('addKeyword')
      const newConcepts = this.videosList.map(concept => {
        return decode(concept.snippet.title)
      })
      const keyword = {
        pillarID: pillar.pillarID,
        data: {
          avgViews: this.avgViews,
          concepts: newConcepts,
          keywordName: this.searchTerm,
        },
        change: 'create',
      }
      this.$store.commit('creator/strategy/insertKeyword', { pillar, keyword })
      this.setHasChanges('create', keyword)
      this.$bvModal.hide('keywordToolModal' + pillar.pillarID)
    },
    deleteKeyword(pillar, keyword) {
      this.$store.commit('creator/strategy/removeKeyword', { pillar, keyword })
      this.setHasChanges('delete', keyword)
    },
    setHasChanges(type, keyword) {
      this.$store.commit('creator/hasChanges')
      console.log(keyword)
      if (type === 'delete') {
        keyword.change = 'delete'
      } else if (keyword.change === 'create') {
      } else keyword.change = 'update'
      console.log(keyword)
    },
    resetParameters() {
      this.isVisibleNewKeywordInput = true
      this.searchTerm = null
      this.searchResult = null
      this.showCommitment = false
      this.videosList = []
      this.allTags = []
      this.autocompleteItems = []
    },
    addNewConcept(pillar, keyword) {
      console.log('addNewConcept')
      const concept = this.conceptName
      const type = 'insert'
      this.setHasChanges('update', keyword)
      this.$store.commit('creator/strategy/updateKeyword', { pillar, keyword, concept, type })
    },
    deleteConcept(pillar, keyword, concept) {
      this.$store.commit('creator/strategy/updateKeyword', { pillar, keyword, concept })
      console.log(keyword)
      this.setHasChanges('update', keyword)
    },
    startProduction(keyword, concept) {
      const payload = {
        tags: keyword.data.keywordName,
        description: concept,
        publishDate: this.publishDate,
      }
      console.log(payload)
      this.$store.commit('creator/videos/insertVideo', {
        payload,
      })
      this.hasChanges()
      this.$router.push('/dashboard')
    },
    hasChanges() {
      this.$store.commit('creator/hasChanges')
    },
  },
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>

<style lang="scss" scoped>
@import '@/components/kit/core/mixins.scss';

  .inner-text {
    background: $primary;
    padding: .2rem;
    border-radius: 5px;
    text-align: center;
    box-shadow: 0 10px 50px rgba(0,0,0,0.6);
    h3 {
      color: white;
    }
  }

  .buttons-row {
    display: flex;
    gap: .5rem;
  }

</style>
